<template>
<div class='body-service index'>
    <div class='box-loop carousel slide' id='loop-banner' data-interval='3000'>
        <ol class='carousel-indicators'>
            <li data-target='#loop-banner' data-slide-to='0' class='active'></li>
            <li data-target='#loop-banner' data-slide-to='1'></li>
        </ol>   
        <div class='carousel-inner'>
            <div class='item active'>
                <img src='/static/image/service/loop.png'>
            </div>
            <div class='item'>
                <img src='/static/image/service/loop-02.png'>
            </div>
        </div>
        <a class='carousel-control left' href='#loop-banner'data-slide='prev'> 
            <span class='glyphicon glyphicon-chevron-left'></span>
        </a>
        <a class='carousel-control right' href='#loop-banner'data-slide='next'> 
            <span class='glyphicon glyphicon-chevron-right'></span>
        </a>
    </div>
    <div class='box-ops'>
        <div class='container'>
            <div class='yi-title'>快捷操作</div>
            <div class='row'>
                <div class='col-md-12'>
                    <div class='row'>
                        <div class='col-md-3'>
                            <div class='box-item' @click='toUrl("/service/faq")'>
                                <div class='box-icon'>
                                    <img src='/static/image/service/icon-question.png'>
                                </div>
                                <div class='name'>常见问题</div>
                            </div>
                        </div>
                        <div class='col-md-2'>
                            <div class='box-item' @click='callAbbr()'>
                                <div class='box-icon'>
                                    <img src='/static/image/service/icon-kefu.png'>
                                </div>
                                <div class='name'>在线客服</div>
                            </div>
                        </div>
                        <!--<div class='col-md-2'>
                            <div class='box-item'>
                                <div class='box-icon'>
                                    <img src='/static/image/service/icon-zizhu.png'>
                                </div>
                                <div class='name'>自主服务</div>
                            </div>
                        </div>-->
                        <div class='col-md-2'>
                            <div class='box-item' @click='toUrl("/recharge/log")'>
                                <div class='box-icon'>
                                    <img src='/static/image/service/icon-recharge.png'>
                                </div>
                                <div class='name'>账号与充值</div>
                            </div>
                        </div>
                        <div class='col-md-2'>
                            <div class='box-item' @click='toUrl("/service/faq?type=lost")'>
                                <div class='box-icon'>
                                    <img src='/static/image/service/icon-tousu.png'>
                                </div>
                                <div class='name'>投诉与建议</div>
                            </div>
                        </div>
                        <div class='col-md-3'>
                            <div class='box-item' @click='toUrl("/service/log")'>
                                <div class='box-icon'>
                                    <img src='/static/image/service/icon-service.png'>
                                </div>
                                <div class='name'>服务记录</div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class='row'>
                        <div class='col-md-4'>
                            <div class='box-info'>
                                <img src='/static/image/service/icon-mobile.png' class='icon-img'>
                                <div class='title'>热线电话</div>
                                <div class='cont'>客服电话：1165232</div>
                            </div>
                        </div>
                        <div class='col-md-4'>
                            <div class='box-info'>
                                <img src='/static/image/service/icon-mobile.png' class='icon-img'>
                                <div class='title'>客服投诉</div>
                                <div class='cont'>邮箱：116164@qq.com</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Common from '@/common/Common'
import ScrollReveal from 'scrollreveal'
export default {
    methods : {

        toUrl : function(url){
            Common.toUrl(url)
        },

        callAbbr : function(){
            Common.callAbbr()
        }
    },
    mounted : function(){
        var sr = ScrollReveal({
            'origin' : 'bottom',
            'distance' : '200px',
            'duration' : 500,
            'delay' : 100
        });
        $(function(){
            $('.box-item').each(function(index){
                sr.reveal($(this), {
                    delay : index * 100,
                    origin : 'right'
                })
            })
            $('.box-info').each(function(index){
                sr.reveal($(this), {
                    delay : index * 300,
                    origin : 'bottom'
                })
            })
        })
    },
    created : function(){
        window.scrollTo(0, 0)
    }
}
</script>


// WEBPACK FOOTER //
// src/components/service/Index.vue